import { useLocation, useNavigate } from 'react-router-dom'

export default function AccessDenied() {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-6 text-center">
      <div className="text-5xl mb-4">🚫</div>
      <h1 className="text-xl font-semibold text-white mb-2">Access Denied</h1>
      <p className="text-gray-400 text-sm mb-1">
        You don't have permission to view this page.
      </p>
      <p className="text-gray-600 text-xs font-mono mb-6">{location.pathname}</p>
      <button
        onClick={() => navigate(-1)}
        className="px-4 py-2 text-sm rounded-lg bg-gray-800 hover:bg-gray-700 text-gray-300 transition-colors"
      >
        Go Back
      </button>
    </div>
  )
}
